import { getFirebase } from "react-redux-firebase";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createMigrate, persistReducer, persistStore } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

import { ClipboardTransform } from "store/clipboard";
import reducers from "store/reducers";

// middleware
const enhancers = composeWithDevTools(applyMiddleware(thunk.withExtraArgument(getFirebase)));

// redux-persist
const migrations = {
  0: (state) => {
    const { cards, commander } = state.clipboard;

    const newCards = {};
    Object.values(cards).forEach(({ url }) => {
      newCards[url] = null;
    });
    const newCommander =
      commander === null
        ? undefined
        : typeof commander === "object"
        ? commander.url
        : commander.length === 0
        ? null
        : commander;

    return {
      clipboard: {
        ...state.clipboard,
        cards: newCards,
        commander: newCommander,
      },
    };
  },
};
const persistConfig = {
  key: "root",
  migrate: createMigrate(migrations, { debug: false }),
  stateReconciler: hardSet,
  storage,
  transforms: [ClipboardTransform],
  version: 0,
  whitelist: ["alternateArt", "clipboard", "settings"],
};
const rootReducer = combineReducers({
  ...reducers,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore(preloadedState) {
  const store = createStore(persistedReducer, preloadedState, enhancers);
  const persistor = persistStore(store);
  return { persistor, store };
}
